const gu = {
    loginTitle: "લૉગિન",
    selectUser: "પ્રવેશ વપરાશકર્તા પસંદ કરો",
    admin: "એડમિન",
    superAdmin: "સુપર એડમિન",
    mobileNumber: "મોબાઇલ નંબર",
    password: "*********",
    enterPassword: "પાસવર્ડ દાખલ કરો",
    rePassword: "પાસવર્ડ ફરીથી દાખલ કરો",
    rememberMe: "મને યાદ રાખો",
    forgotPassword: "પાસવર્ડ ભૂલી ગયા?",
    loginButton: "લૉગિન",
    orLoginWith: "અથવા સાથે લૉગિન કરો",
    google: "ગૂગલ",
    apple: "ઍપલ",
    dontHaveAccount: "એકાઉન્ટ નથી?",
    signUp: "સાઇન અપ",
    enterYourNumberToRecieveACode: "તમારો પાસવર્ડ રીસેટ કરવા માટે કોડ મેળવવા તમારો ફોન નંબર દાખલ કરો.",
    gender: "લિંગ",
    male: "પુરુષ",
    female: "સ્ત્રી",
    firstName: "પ્રથમ નામ",
    middleName: "મધ્યમ નામ",
    lastName: "અંતિમ નામ",
    verify: "ચકાસો",
    email: "ઇમેઇલ",
    twoStepVerification: "બે પગલાની ચકાસણી",
    verification: "ચકાસણી",
    otpVerifyText: "વધુ સુરક્ષિતતા માટે, કૃપા કરીને એક વખતનો પાસવર્ડ (OTP) દાખલ કરો જે મોબાઇલ નંબર પર મોકલવામાં આવ્યો છે.",
    pleaseWait: "કૃપા કરીને રાહ જુઓ",
    seconds: "સેકંડ",
    didntReceiveCode: "કોડ પ્રાપ્ત થયો નથી?",
    resendCode: "કોડ ફરીથી મોકલો",
    getOtp: "ઓટીપી મેળવો",
    createPassword: "નવો પાસવર્ડ બનાવો",
    passwordValidation: "નવા પાસવર્ડમાં ઓછામાં ઓછું એક હોવું જોઈએ:",
    includesCharacters: "8-16 અક્ષરો શામેલ છે",
    includesNumber: "આંકડો",
    includesSpecialChar: "વિશિષ્ટ અક્ષર",
    includesLowercase: "લોઅરકેસ અક્ષર",
    includesUppercase: "અપરકેસ અક્ષર",
    welcome: "સ્વાગત છે",
    welcomeDescription: "આફ્રિકામાં આબોહવા પરિવર્તન અને વિકાસ પર સંશોધન, તાલીમ અને ડેટા વિશ્લેષણ માટે શ્રેષ્ઠતા માટેનું અગ્રણી કેન્દ્ર બનવું.",
    niccrra: "NICCRRA.",
    allCopyRightReserved: "બધા હક્કો અનામત છે.",

    // user profile 
    profile: "પ્રોફાઇલ",
    changePassword: "પાસવર્ડ બદલો",
    logout: "લૉગ આઉટ",
    editProfile: "પ્રોફાઇલ સંપાદિત કરો",
    updateProfile: "પ્રોફાઇલ અપડેટ કરો",

    // Side Menu Items
    dashboard: "ડેશબોર્ડ",
    farmers: "ખેડૂતો",
    taskAssignment: "કાર્ય સોંપણી",
    dataCollectors: "ડેટા સંકલક",
    reportSubmission: "અહેવાલ રજૂઆત",
    userManagement: "વપરાશકર્તા વ્યવસ્થાપન",
    roleManagement: "ભૂમિકા વ્યવસ્થાપન",
    regionAndLocality: "પ્રદેશ અને સ્થાનિકતા",
    typeOfCrops: "વિભિન્ન પાક",
    typeOfLivestock: "વિભિન્ન પશુપાલન",
    typeOfPisciculture: "વિભિન્ન માછીમારી",
    typeOfMachinery: "વિભિન્ન યાંત્રિકતા",
    certificationsAndTraining: "પ્રમાણપત્ર અને તાલીમ",
    trainingProgram: "તાલીમ કાર્યક્રમ",
    whoSponsored: "યાર દ્વારા પ્રાયોજિત",

    // Dashboard Cards
    totalFarmersRegistered: "કુલ નોંધાયેલા ખેડૂતો",
    pendingFarmerApprovals: "બાકી ખેડૂત મંજૂરીઓ",
    taskAssignmentNotifications: "કાર્ય સોંપણી સૂચનાઓ",
    totalDataCollectors: "કુલ ડેટા સંકલક",

    // Dashboard 
    performanceMetricsOfDataCollectors: "ડેટા સંકલકના કાર્યક્ષમતા મેટ્રિક્સ",
    today: "આજે",
    thisWeek: "આ અઠવાડિયે",
    thisMonth: "આ મહિને",

    // Farmers
    farmersList: "ખેડૂતોની યાદી",
    srNo: "Sr. No",
    photo: "ફોટો",
    farmerName: "ખેડૂત નામ",
    date: "તારીખ",
    dataCollectorName: "ડેટા સંકલક નામ",
    mobileNo: "મોબાઇલ નંબર",
    location: "સ્થાન",
    statusView: "સ્થિતિ / જુઓ",
    clear: "સ્પષ્ટ",
    selectStatus: "સ્થિતિ પસંદ કરો",
    approved: "મંજૂર",
    pending: "બાકી",
    reject: "નકારો",
    selectTimePeriod: "સમયગાળો પસંદ કરો",
    fromDate: "તારીખથી",
    toDate: "તારીખ સુધી",
    today: "આજે",
    week: "અઠવાડી",
    month: "મહિનો",
    year: "વર્ષ",
    selectLocation: "સ્થાન પસંદ કરો",
    selectFarmingCategory: "ખેતી વર્ગ પસંદ કરો",
    selectInfrastructureProximity: "મુળભૂત નજીકતા પસંદ કરો",
    selectGender: "લિંગ પસંદ કરો",
    selectRegion: "પ્રદેશ પસંદ કરો",
    submit: "સબમિટ",
    cancel: "રદ કરો",
    farmersDetailsView: "ખેડૂતોની વિગતો જુઓ",
    reject: "નકારો",
    personalDetails: "વ્યક્તિગત વિગતો",
    locationDetails: "સ્થાન વિગતો",
    farmingDetails: "ખેત ખેડ વિગતો",
    farmOwnershipDetails: "ખેતર માલિકી વિગતો",
    accessToFinance: "વિત્તિ સુધીની ઍક્સેસ",
    dateOfBirth: "જન્મ તારીખ",
    alternateMobileNumber: "વૈકલ્પિક મોબાઇલ નંબર",
    nationalIdentificationNo: "રાષ્ટ્રીય ઓળખપત્ર નંબર",
    address: "સરનામું",
    latitude: "અક્ષાંશ અને દેશાંશ",
    selectFarmingDetails: "ખેડી વિગતો પસંદ કરો",
    filter: "ફિલ્ટર",
    rejectDescription: "નકારો વર્ણન",
    pleaseSelectReasonForRejection: "કૃપા કરીને નકારવાનો કારણ પસંદ કરો",
    pleaseEnterCommentForRejection: "કૃપા કરીને નકારવા માટે ટિપ્પણી દાખલ કરો",

    // Farming Details
    educationLevel: "શિક્ષણ સ્તર",
    farmingExperience: "ખેત ખેડ અનુભવ",
    farmSizeInHectares: "ખેતની સાધન (હેક્ટર)",
    typesOfCrops: "પાકોના પ્રકારો",
    cereals: "અનાજ",
    legumes: "શીમ",
    rootsAndTubers: "મૂળો અને કંદમૂળ",
    vegetables: "શાકભાજી",
    fruits: "ફળ",
    cashCrops: "નગદી પાક",
    typesOfLivestock: "પશુપાલનના પ્રકારો",
    cattle: "ઢોર",
    poultry: "કુક્કુટ",
    smallRuminants: "નાના ચૂસણારા",
    beefCattle: "ગાય-ભેંસ",
    chickens: "મૂર્ગી",
    goats: "બકરા",
    typesOfPisciculture: "મત્સ્યઉદ્યોગના પ્રકાર",
    farmingMethods: "ખેતી પદ્ધતિઓ",
    years: "વર્ષ",
    hectares: "હેક્ટર",

    // Farm Ownership Details
    farmOwnership: "ખેતર માલિકી",
    ownership: "માલિકી",
    owned: "માલિકી",
    titled: "શીર્ષક",
    leased: "કિરાયે",
    untitled: "શીર્ષક વગર",
    infrastructureDetails: "મુળભૂત માળખાંની વિગતો",
    farmerHouse: "ખેડૂતનું ઘર",
    farmer: "ખેડૂત",
    warehouse: "ગોડાઉન",
    accessToRoadAndDistance: "રસ્તા અને અંતર માટેની ઍક્સેસ",
    available: "ઉપલબ્ધ",
    notAvailable: "ઉપલબ્ધ નથી",
    processingPlants: "પ્રક્રિયા પ્લાંટ",
    typesOfMachinery: "યાંત્રિક પ્રકારો",
    tillageEquipment: "ખેતી સાધનો",
    industrial: "ઔદ્યોગિક",
    mini: "મિની",
    handPush: "હેન્ડ પુશ",
    plows: "હળ",
    moldboard: "મોલ્ડબોર્ડ",
    disc: "ડિસ્ક",
    harrows: "હેરો",
    plantingEquipment: "પાક વાવેતર સાધનો",
    seedDrills: "બીજ ડ્રિલ્સ",
    planters: "પ્લાન્ટર્સ",
    transplanter: "ટ્રાન્સપ્લાન્ટર",
    rice: "ચોખા",
    vegetables: "શાકભાજી",
    agriculturalCertifications: "અગ્રણી પ્રમાણપત્ર",
    otherCertifications: "અન્ય પ્રમાણપત્ર",
    otherTrainingPrograms: "અન્ય તાલીમ કાર્યક્રમ",
    whoSponsoredTheTraining: "તાલીમ કોણે પ્રાયોજિત કરી",
    otherTrainingSponsors: "અન્ય તાલીમ પ્રાયોજકો",
    sponsoredTraining: "પ્રાયોજિત તાલીમ",

    // Access to Finance
    accessToFinance: "વિત્તિ સુધીની ઍક્સેસ",
    loansFromGovernmentBank: "સરકારી બેંકમાંથી લોન",
    loansFromCommercialBank: "વાણિજ્ય બેંકમાંથી લોન",
    grantsFromINGOs: "INGOs / વિકાસ ભાગીદાર પાસેથી ગ્રાન્ટ",
    emergencyContactDetails: "એમર્જન્સી સંપર્ક વિગતો",

    //Task Assignment
    taskAssign: "કાર્ય સોંપણી",
    dataCollector: "ડેટા સંકલક",
    description: "વર્ણન",
    region: "પ્રદેશ",
    state: "રાજ્ય",
    localGovernment: "સ્થાનિક સરકાર",
    noOfFarmers: "ખેડૂતોની સંખ્યા",
    completed: "પૂર્ણ",
    deadline: "અંતિમ તારીખ",

    // Task Assignment Form
    enterTaskTitle: "કાર્ય શીર્ષક દાખલ કરો",
    taskDescription: "કાર્ય વર્ણન",
    selectState: "રાજ્ય પસંદ કરો",
    selectLocalGovernment: "સ્થાનિક સરકાર પસંદ કરો",
    selectDataCollector: "ડેટા સંકલક પસંદ કરો",
    enterNumberOfFarmers: "ખેડૂતોની સંખ્યા દાખલ કરો",
    notification: "સૂચના",
    assignTask: "કાર્ય સોંપો",
    on: "ચાલુ",
    off: "બંધ",
    pleaseEnterTaskTitle: "કૃપા કરીને કાર્ય શીર્ષક દાખલ કરો",
    pleaseEnterTaskDescription: "કૃપા કરીને કાર્ય વર્ણન દાખલ કરો",
    pleaseSelectLocalGovernment: "કૃપા કરીને સ્થાનિક સરકાર પસંદ કરો",
    pleaseSelectDataCollector: "કૃપા કરીને ડેટા સંકલક પસંદ કરો",
    pleaseEnterNumberOfFarmers: "કૃપા કરીને ખેડૂતોની સંખ્યા દાખલ કરો",
    numberOfFarmerCantBeDecimal: "ખેડૂતોની સંખ્યા દશાંશમાં ન હોઈ શકે",
    numberOfFarmerCantBeZero: "ખેડૂતોની સંખ્યા 0 ન હોઈ શકે",
    deadlineCantBePastDate: "અંતિમ તારીખ પાછલી તારીખ ન હોઈ શકે",
    deadlineTooFarInFuture: "અંતિમ તારીખ મોટું તારીખ ન હોઈ શકે",
    pleaseEnterDeadline: "કૃપા કરીને અંતિમ તારીખ દાખલ કરો",
    fromDateCantBeGreaterThanToday: "શરૂઆતની તારીખ આજની તારીખ કરતાં મોટી ન હોઈ શકે",
    toDateCantBeGreaterThanToday: "અંતિમ તારીખ આજની તારીખ કરતાં મોટી ન હોઈ શકે",
    fromDateCantBeAfterToDate: "શરૂઆતની તારીખ અંતિમ તારીખ પછી ન હોઈ શકે",
    toDateCantBeBeforeFromDate: "અંતિમ તારીખ શરૂઆતની તારીખ પહેલાં ન હોઈ શકે",
    editAssignTask: "કાર્ય સોંપણી સંપાદિત કરો",

    // Task Details
    taskDetailsView: "કાર્ય વિગતો જુઓ",
    taskReportDetailsView: "કાર્ય અહેવાલ વિગતો જુઓ",
    status: "સ્થિતિ",
    sendReminder: "રીમાઇન્ડર મોકલો",
    farmersRegistered: "નોંધાયેલા ખેડૂતો",
    summary: "સારાંશ",
    taskTitle: "કાર્ય શીર્ષક",
    attachments: "જોડાણો",
    sendReminder: "રીમાઇન્ડર મોકલો",
    enterReminderTitle: "રીમાઇન્ડર શીર્ષક દાખલ કરો",
    tasksReportSubmission: "કાર્ય અહેવાલ રજૂઆત",
    yes: "હા",
    no: "ના",
    edit: "સુધારો",
    Update: "અપડેટ",
    delete: "ડિલીટ",

    // Data collectors
    addCollector: "ડેટા સંકલક ઉમેરો",
    name: "નામ",
    dataCollectorName: "ડેટા સંકલક નામ",
    active: "સક્રિય",
    inactive: "નિષ્ક્રિય",
    pleaseEnterFirstName: "કૃપા કરીને પ્રથમ નામ દાખલ કરો",
    pleaseEnterMiddleName: "કૃપા કરીને મધ્યમ નામ દાખલ કરો",
    pleaseEnterLastName: "કૃપા કરીને છેલ્લું નામ દાખલ કરો",
    pleaseSelectGender: "કૃપા કરીને લિંગ પસંદ કરો",
    pleaseEnterMobileNumber: "કૃપા કરીને મોબાઇલ નંબર દાખલ કરો",
    pleaseEnterEmail: "કૃપા કરીને ઇમેઇલ દાખલ કરો",
    pleaseEnterValidEmail: "કૃપા કરીને માન્ય ઇમેઇલ દાખલ કરો",
    pleaseEnterPassword: "કૃપા કરીને પાસવર્ડ દાખલ કરો",
    pleaseReEnterPassword: "કૃપા કરીને પાસવર્ડ ફરીથી દાખલ કરો",
    passwordMismatch: "પાસવર્ડ અને પુષ્ટિ પાસવર્ડ સમાન નથી",
    passwordValidation: "પાસવર્ડ 8-16 અક્ષરો લાંબો હોવો જોઈએ અને તેમાં ઓછામાં ઓછું એક અપરકેસ અક્ષર, એક લોઅરકેસ અક્ષર, એક આંકડો અને એક વિશિષ્ટ અક્ષર શામેલ હોવો જોઈએ.",

    //Crops
    demoFile: "ડેમો ફાઇલ",
    importFile: "ફાઇલ આયાત કરો",
    addCrop: "પાક ઉમેરો",
    EnterCropName: "પાકનું નામ દાખલ કરો",
    Cancel: "રદ કરો",
    editCrop: "પાક સુધારો",
    updateCrop: "પાક અપડેટ કરો",
    deleteCrop: "આ પાક ડિલીટ કરો",
    cropdeleted: "શું તમે ખોટું કરવા માંગો છો",
    deleted: "આ પાક ડિલીટ કરવું છે?",
    yes: "હા",
    no: "ના",
    ImportExcel: "એક્સેલ આયાત કરો",

    // Region and Locality
    addRegion: "પ્રદેશ ઉમેરો",
    addState: "રાજ્ય ઉમેરો",
    addLocalGovernment: "સ્થાનિક સરકાર ઉમેરો",
    enterRegion: "પ્રદેશ દાખલ કરો",
    enterState: "રાજ્ય દાખલ કરો",
    enterLocalGovernment: "સ્થાનિક સરકાર દાખલ કરો",
    searchHere: "અહીં શોધો",
    regionAndLocality: "પ્રદેશ અને સ્થાનિકતા",
    demoFile: "ડેમો ફાઇલ",
    importExcel: "એક્સેલ આયાત કરો",
    submit: "સબમિટ",
    cancel: "રદ કરો",
    pleaseSelectRegionName: "કૃપા કરીને પ્રદેશનું નામ પસંદ કરો",
    pleaseSelectRegion: "કૃપા કરીને પ્રદેશ પસંદ કરો",
    pleaseEnterStateName: "કૃપા કરીને રાજ્યનું નામ દાખલ કરો",
    pleaseSelectState: "કૃપા કરીને રાજ્ય પસંદ કરો",
    pleaseEnterLocalGovernmentName: "કૃપા કરીને સ્થાનિક સરકારનું નામ દાખલ કરો",
    noOptionAvailable: "કોઈ વિકલ્પ ઉપલબ્ધ નથી",

    // Region Table
    regionName: "પ્રદેશનું નામ",
    stateName: "રાજ્યનું નામ",
    localGovernmentName: "સ્થાનિક સરકારનું નામ",
    editRegion: "પ્રદેશ સંપાદિત કરો",
    editState: "રાજ્ય સંપાદિત કરો",
    editLocalGovernment: "સ્થાનિક સરકાર સંપાદિત કરો",
    updateRegion: "પ્રદેશ અપડેટ કરો",
    updateState: "રાજ્ય અપડેટ કરો",
    updateLocalGovernment: "સ્થાનિક સરકાર અપડેટ કરો",
    deleteRegion: "આ પ્રદેશ ડિલીટ કરો",
    deleteState: "આ રાજ્ય ડિલીટ કરો",
    deleteLocalGovernment: "આ સ્થાનિક સરકાર ડિલીટ કરો",
    deleteRegionConfirmation: "શું તમે આ પ્રદેશને ડિલીટ કરવા માંગો છો?",
    deleteStateConfirmation: "શું તમે આ રાજ્યને ડિલીટ કરવા માંગો છો?",
    deleteLocalGovernmentConfirmation: "શું તમે આ સ્થાનિક સરકારને ડિલીટ કરવા માંગો છો?",
    yes: "હા",
    no: "ના",
    cancel: "રદ કરો",
    submit: "સબમિટ",
    edit: "સુધારો",
    delete: "ડિલીટ",
    pleaseEnterRegion: "કૃપા કરીને પ્રદેશનું નામ દાખલ કરો.",
    pleaseSelectRegionName: "કૃપા કરીને પ્રદેશનું નામ પસંદ કરો.",
    pleaseEnterStateName: "કૃપા કરીને રાજ્યનું નામ દાખલ કરો.",
    pleaseEnterLocalGovernmentName: "કૃપા કરીને સ્થાનિક સરકારનું નામ દાખલ કરો.",

    // user management
    role: "ભૂમિકા",
    activate: "સક્રિય કરો",
    deactivate: "નિષ્ક્રિય કરો",
    update: "અપડેટ કરો",
    approve: "સુવિધી કરો",

    // role management
    addRole: "ભૂમિકા ઉમેરો",
    roleName: "ભૂમિકા નામ",
    pleaseEnterRoleName: "કૃપા કરીને ભૂમિકા નામ દાખલ કરો.",
    userRole: "પ્રકાર",
    permissions: "પ્રવેશિઝ્સ",
    action: "વિગત",
    editRole: "ભૂમિકા સુધારો",
    updateRole: "ભૂમિકા અપડેટ કરો",
    deleteRole: "આ ભૂમિકા ડિલીટ કરો",
    deleteRoleConfirmation: "શું તમે આ ભૂમિકા ને ડિલીટ કરવા માંગો છો?",
    roleNameRequired: "કૃપા કરીને ભૂમિકા નામ દાખલ કરો.",

    downloadSuccess: "ડાઉનલોડ સફળતાપૂર્વક થઇ ગયું છે",

    // Livestock
    searchHere: "અહીં શોધો",
    search: "શોધો",
    typesOfLivestock: "પશુપાલનના પ્રકારો",
    addLivestock: "પશુપાલન ઉમેરો",
    enterLivestock: "પશુપાલન દાખલ કરો",
    editLivestock: "પશુપાલન સુધારો",
    updateLivestock: "પશુપાલન અપડેટ કરો",
    deleteLivestock: "આ પશુપાલન ડિલીટ કરો",
    deleteLivestockConfirmation: "શું તમે આ પશુપાલન ડિલીટ કરવા માંગો છો?",

    // Pisiciculture
    addPisciculture: "મત્સ્યઉદ્યોગ ઉમેરો",
    enterPisciculture: "મત્સ્યઉદ્યોગ દાખલ કરો",
    editPisciculture: "મત્સ્યઉદ્યોગ સુધારો",
    updatePisciculture: "મત્સ્યઉદ્યોગ અપડેટ કરો",
    deletePisciculture: "આ મત્સ્યઉદ્યોગ ડિલીટ કરો",
    deletePiscicultureConfirmation: "શું તમે આ મત્સ્યઉદ્યોગ ડિલીટ કરવા માંગો છો?",

    // Machinery
    addMachinery: "યંત્રસામગ્રી ઉમેરો",
    enterMachinery: "યંત્રસામગ્રી દાખલ કરો",
    enterSubCategory: "ઉપ-શ્રેણી દાખલ કરો",
    editMachinery: "યંત્રસામગ્રી સુધારો",
    updateMachinery: "યંત્રસામગ્રી અપડેટ કરો",
    deleteMachinery: "આ યંત્રસામગ્રી ડિલીટ કરો",
    deleteMachineryConfirmation: "શું તમે આ યંત્રસામગ્રી ડિલીટ કરવા માંગો છો?",
    subCategory: "ઉપ-શ્રેણી",

    // certifications and training
    addCertificationAndTraining: "પ્રમાણપત્ર અને તાલીમ ઉમેરો",
    enterCertificationAndTraining: "પ્રમાણપત્ર અને તાલીમ દાખલ કરો",
    editCertificationAndTraining: "પ્રમાણપત્ર અને તાલીમ સુધારો",
    updateCertificationAndTraining: "પ્રમાણપત્ર અને તાલીમ અપડેટ કરો",
    deleteCertificationAndTraining: "આ પ્રમાણપત્ર અને તાલીમ ડિલીટ કરો",
    deleteCertificationAndTrainingConfirmation: "શું તમે આ પ્રમાણપત્ર અને તાલીમ ડિલીટ કરવા માંગો છો?",

    // Training programs
    typesOfTrainingProgram: "પશુપાલનના પ્રકારો",
    addTrainingProgram: "પશુપાલન ઉમેરો",
    enterTrainingProgram: "પશુપાલન દાખલ કરો",
    editTrainingProgram: "પશુપાલન સુધારો",   
    updateTrainingProgram: "પશુપાલન અપડેટ કરો",
    deleteTrainingProgram: "આ પશુપાલન ડિલીટ કરો",
    deleteTrainingProgramConfirmation: "શું તમે આ પશુપાલન ડિલીટ કરવા માંગો છો?",

    // Who Sponsored
    addSponsor: "સપન્સર ઉમેરો",
    sponsoredName: "સપન્સરનું નામ",
    enterSponsor: "સપન્સર દાખલ કરો",
    editSponsor: "સપન્સર સુધારો",
    updateSponsor: "સપન્સર અપડેટ કરો",
    deleteSponsor: "આ સપન્સર ડિલીટ કરો",
    deleteSponsorConfirmation: "શું તમે આ સપન્સર ડિલીટ કરવા માંગો છો?",

    // Import File 
    pleaseSelectFile: "કૃપા કરીને ફાઇલ પસંદ કરો",

    // User profile 
    firstNameIsRequired: "પ્રથમ નામ જરૂરી છે",
    middleNameIsRequired: "મધ્યમ નામ જરૂરી છે",
    lastNameIsRequired: "છેલ્લું નામ જરૂરી છે",
    genderIsRequired: "લિંગ જરૂરી છે",
    mobileNumberIsRequired: "મોબાઇલ નંબર જરૂરી છે",
    emailIsRequired: "ઈમેઇલ જરૂરી છે",

    // No access 
    youDontHaveAccess: "તમે આ પાનું મળવાની માટે અપરવાઇન નથી",
};

export default gu;